function SocksIco(isWhite) {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.5 2V13L11 19.5H7.5L6 18V14.5L10.5 10V2H16.5Z" fill="white" />
      <path
        d="M15.9931 1.45218L15.9922 1.45156H16.4592C16.867 1.45156 17.1975 1.78197 17.1975 2.18978L15.9931 1.45218ZM15.9931 1.45218H10.2039C9.7961 1.45218 9.4657 1.78251 9.4656 2.19026C9.46433 3.12889 9.46488 4.82746 9.46542 6.47529C9.46586 7.85454 9.4663 9.19825 9.46565 10.031L6.0021 13.5232C4.40904 15.1293 4.40841 17.7477 6.00179 19.3638C7.54128 20.9714 10.2918 20.9708 11.8227 19.3525L15.9931 1.45218ZM15.7219 13.1101V5.73335H10.9423V10.3358C10.9423 10.5306 10.8659 10.7171 10.7285 10.8554C10.7285 10.8555 10.7285 10.8555 10.7285 10.8555L7.05112 14.5632L7.0511 14.5633C6.02569 15.5968 6.02526 17.2854 7.05214 18.3256L7.05381 18.3273L7.05379 18.3273C8.02912 19.347 9.78184 19.3512 10.7577 18.3308L15.7219 13.1101ZM15.7219 13.1101L10.758 18.3305L15.7219 13.1101ZM11.823 19.3522L16.9945 13.9135L16.9945 13.9134C17.125 13.7761 17.1975 13.5937 17.1975 13.4046V13.4046C17.1971 12.3997 17.1973 10.0566 17.1975 7.73284C17.1977 5.42001 17.1979 3.12625 17.1975 2.18984L11.823 19.3522ZM15.7218 2.92874V4.25608H10.9422V2.92874H15.7218Z"
        fill={isWhite ? "white" : "#667085"}
        stroke={isWhite ? "white" : "#667085"}
        stroke-width="0.3"
      />
      <rect x="17.5508" y="1" width="1" height="2" fill="white" />
    </svg>
  );
}

export default SocksIco;
